import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryLoyaltyPoints.js';
import { RichText } from '@synergycms_core/components/generic';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import { FIDELTOUR_CODE } from '@synergycms_app/store/customer/loyaltyActions';

const AvailMainSideSummaryLoyaltyPoints = class AvailMainSideSummaryLoyaltyPoints extends React.Component {
  static displayName = 'AvailMainSideSummaryLoyaltyPoints';

  render() {
    const { config, theme } = this.props,
      {
        accumulatePoints,
        loyalty
      } = config;

    const { classes } = theme.styles;
    const cx = theme.bind();

    return (
      <div className={[classes.contentModule].join(' ')}>
        <div className={[classes.contentModuleRow].join(' ')}>
          <div className={[classes.contentModuleCell, classes.large].join(' ')}>
            <RichText text={'_%acumularás%_'} ucFirst={true} innerStyle={['roboto16BoldBlack400', 'capitalize', 'mainColor', cx({stDefault: loyalty?.get('code') !== FIDELTOUR_CODE })]} translate={true}/>
          </div>

          <div className={[classes.contentModuleCell, classes.contentModuleCellPrice, classes.short].join(' ')}>
            <RichText text={'_%+{accumulatePoints} puntos%_'} innerStyle={['roboto16BoldBlack400', 'capitalize', 'mainColor', cx({stDefault: loyalty?.get('code') !== FIDELTOUR_CODE })]} translate={true} withVars={{accumulatePoints: accumulatePoints}}/>
            <RichText text={'_%aproximados%_'} innerStyle={['roboto11Black400', cx({stDefault: loyalty?.get('code') !== FIDELTOUR_CODE })]} translate={true}/>
          </div>
        </div>
      </div>
    );
  }
};

export default compose(
  PropertyManager([
    'accumulatePoints',
    'loyalty'
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryLoyaltyPoints);
